module.exports = __webpack_public_path__ + "img/nt116-01-81-1.prt.bc4b6dde.jpg";